<template>
	<div class="create-plugin">
		<div class="config-header">
			<el-page-header @back="$emit('back')" :content="form.id ? '编辑插件' : '插件配置'"></el-page-header>
			<div class="actions">
				<el-button size="small" @click="$emit('back')">取消</el-button>
				<el-button type="primary" size="small" :loading="submitting" @click="handleSave">保存并发布</el-button>
			</div>
		</div>

		<el-form ref="form" :model="form" :rules="rules" label-position="top" class="main-form">
			<el-tabs v-model="activeTab">
				<el-tab-pane label="样式设置" name="style">

					<div class="section">
						<h4 class="section-title">基础设置</h4>
						<el-form-item label="插件名称" prop="name">
							<el-input v-model="form.name" placeholder="插件名称仅作为内部管理识别" maxlength="50"
								show-word-limit></el-input>
						</el-form-item>

						<div class="form-row">
							<el-form-item label="主题颜色" class="flex-1">
								<div class="color-list">
									<div v-for="c in presets" :key="c"
										:class="['color-dot', { active: form.site_color === c }]"
										:style="{ background: c }" @click="form.site_color = c">
										<i v-if="form.site_color === c" class="el-icon-check"></i>
									</div>
									<el-color-picker v-model="form.site_color" size="mini"></el-color-picker>
								</div>
							</el-form-item>

							<el-form-item label="语言" class="flex-1 ml-20">
								<el-select v-model="form.lang" placeholder="请选择语言" style="width:100%">
									<el-option v-for="item in langOptions" :key="item.lang" :label="item.label"
										:value="item.lang">
									</el-option>
								</el-select>
							</el-form-item>
						</div>

						<div class="form-row">
							<el-form-item label="设置头像" class="flex-1" prop="logo">
								<div class="avatar-row">
									<div class="avatar-item">
										<div class="upload-box" @click="triggerUpload('logo')">
											<img v-if="form.logo" :src="previewLogo" class="img-full" />
											<i v-else class="el-icon-camera"></i>
										</div>
										<div class="avatar-info">
											<div class="label">商家 Logo</div>
											<div class="tip">建议尺寸100*100</div>
										</div>
									</div>

									<div class="avatar-item ml-20">
										<el-form-item prop="robot_avatar" label-width="0">
											<div class="flex-center">
												<div class="upload-box" @click="triggerUpload('robot_avatar')">
													<img v-if="form.robot_avatar" :src="previewRobotAvatar"
														class="img-full" />
													<i v-else class="el-icon-camera"></i>
												</div>
												<div class="avatar-info">
													<div class="label">机器人头像</div>
													<div class="tip">建议尺寸100*100</div>
												</div>
											</div>
										</el-form-item>
									</div>
								</div>
								<input type="file" ref="fileInput" style="display: none" @change="onFileChange"
									accept="image/*" />
							</el-form-item>

							<el-form-item label="入口及聊天窗位置" class="flex-1 ml-20">
								<el-select v-model="position" style="width:100%">
									<el-option label="靠网站右侧" value="right"></el-option>
									<el-option label="靠网站左侧" value="left"></el-option>
								</el-select>
							</el-form-item>
						</div>
					</div>

					<div class="section">
						<h4 class="section-title">聊天窗样式</h4>
						<div class="form-row">
							<el-form-item label="对话窗口标题" prop="title" class="flex-1">
								<el-input v-model="form.title" placeholder="您的品牌名称" maxlength="50"
									show-word-limit></el-input>
							</el-form-item>
							<el-form-item label="对话窗口副标题" class="flex-1 ml-20">
								<el-switch v-model="enableSubtitle"></el-switch>
							</el-form-item>
						</div>

						<el-form-item label="副标题内容" v-if="enableSubtitle">
							<el-tabs type="border-card">
								<el-tab-pane label="客服在线显示">
									<el-input type="textarea" v-model="onlineMsg" :rows="3"
										placeholder="欢迎联系我们"></el-input>
								</el-tab-pane>
								<el-tab-pane label="客服离线显示">
									<el-input type="textarea" v-model="offlineMsg" :rows="3"
										placeholder="当前客服离线"></el-input>
								</el-tab-pane>
							</el-tabs>
						</el-form-item>

						<el-form-item label="公告栏">
							<el-switch v-model="showNotice"></el-switch>
							<span class="f-13 gray ml-10">对话窗口显示公告栏</span>
						</el-form-item>

						<div v-if="showNotice" class="notice-box-ui">
							<div class="form-row">
								<el-form-item label="选择公告栏颜色" class="flex-1">
									<div class="color-list">
										<div v-for="c in noticePresets" :key="c"
											:class="['color-dot', { active: noticeColor === c }]"
											:style="{ background: c }" @click="noticeColor = c">
											<i v-if="noticeColor === c" class="el-icon-check"></i>
										</div>
									</div>
								</el-form-item>
								<el-form-item label="内容展示样式" class="flex-1 ml-20">
									<el-radio-group v-model="noticeStyle">
										<el-radio label="full">全部铺开</el-radio>
										<el-radio label="roll">轮播形式</el-radio>
									</el-radio-group>
								</el-form-item>
							</div>
							<el-form-item label="公告栏内容">
								<el-input type="textarea" v-model="noticeContent" placeholder="请输入公告内容"></el-input>
							</el-form-item>
							<div class="flex-center">
								<el-switch v-model="enableNoticeJump"></el-switch>
								<span class="f-13 gray ml-10 mr-10">开启点击跳转</span>
								<el-input v-if="enableNoticeJump" v-model="noticeJumpLink" size="small"
									placeholder="请输入跳转链接" class="flex-1"></el-input>
							</div>
						</div>

						<el-form-item label="移动端展示" class="mt-20">
							<el-radio-group v-model="form.mobile_show">
								<el-radio label="full_screen">铺满屏幕</el-radio>
								<el-radio label="not_full_screen">不铺满</el-radio>
							</el-radio-group>
						</el-form-item>
					</div>
				</el-tab-pane>
			</el-tabs>
		</el-form>
	</div>
</template>

<script>
	export default {
		props: {
			editData: {
				type: Object,
				default: () => null
			}
		},
		data() {
			return {
				activeTab: 'style',
				submitting: false,
				presets: ['red', '#409EFF', '#2D5995', '#71AFA4', '#4E865B', '#7A6EBE'],
				noticePresets: ['#E6A23C', '#4366E3', '#13CE66', '#303133', '#F56C6C'],

				enableSubtitle: false,
				showNotice: false,
				enableNoticeJump: false,
				langOptions: [],
				onlineMsg: '',
				offlineMsg: '',
				noticeColor: '#4366E3',
				noticeStyle: 'roll',
				noticeContent: '',
				noticeJumpLink: '',
				position: 'right',
				currentUploadType: '',
				previewLogo: '',
				previewRobotAvatar: '',
				form: {
					id: '',
					name: '',
					site_color: '#409EFF',
					lang: '',
					logo: '',
					robot_avatar: '',
					title: '',
					mobile_show: 'not_full_screen',
					status: 0
				},
				rules: {
					name: [{
						required: true,
						message: '请输入插件名称',
						trigger: 'blur'
					}],
					title: [{
						required: true,
						message: '请输入窗口标题',
						trigger: 'blur'
					}],
					logo: [{
						required: true,
						message: '请上传商家 Logo',
						trigger: 'change'
					}]
				}
			};
		},
		async created() {
			await this.fetchConfig();
			// 如果有传入 id，则请求接口拿取最新数据回显
			const id = this.editData?.id || this.$route.query.id;
			if (id) {
				this.form.id = id;
				this.getDetail();
			}
		},
		methods: {
			// 获取详情接口
			async getDetail() {
				try {
					const res = await this.$axios.get(this.$apis.getChannel, {
						id: this.form.id
					});
					if (res && res.code === 1) {
						this.renderFormData(res.data);
					}
				} catch (err) {
					this.$message.error('获取详情失败');
				}
			},

			// 解析接口返回的数据到表单
			renderFormData(d) {
				this.form.name = d.name;
				this.form.site_color = d.site_color || '#409EFF';
				this.form.lang = d.lang;
				this.form.logo = d.logo;
				this.form.robot_avatar = d.robot_avatar || '';
				this.form.title = d.title;
				this.form.mobile_show = d.mobile_show || 'not_full_screen';
				this.form.status = d.status;

				// 预览图回显
				this.previewLogo = d.logo;
				this.previewRobotAvatar = d.robot;

				// 1. 解析副标题 JSON 字符串
				if (d.subtitle) {
					try {
						const sub = JSON.parse(d.subtitle);
						this.enableSubtitle = sub.switch === 1;
						this.onlineMsg = sub.content?.online || '';
						this.offlineMsg = sub.content?.offline || '';
					} catch (e) {
						console.warn("subtitle parse error");
					}
				}

				// 2. 解析公告栏 JSON 字符串
				if (d.notice) {
					try {
						const not = JSON.parse(d.notice);
						this.showNotice = not.switch === 1;
						this.noticeColor = not.color || '#4366E3';
						this.noticeStyle = not.type === 'all' ? 'full' : 'roll';
						this.noticeContent = not.content || '';
						if (not.jump) {
							this.enableNoticeJump = not.jump.switch === 1;
							this.noticeJumpLink = not.jump.url || '';
						}
					} catch (e) {
						console.warn("notice parse error");
					}
				}
			},

			async fetchConfig() {
				try {
					const res = await this.$axios.get(this.$apis.getConfig);
					if (res && res.code === 1) {
						this.langOptions = res.data.langList || [];
						if (this.langOptions.length > 0 && !this.form.lang) {
							this.form.lang = this.langOptions[0].lang;
						}
					}
				} catch (err) {
					console.error('fetch config fail');
				}
			},

			triggerUpload(type) {
				this.currentUploadType = type;
				this.$refs.fileInput.click();
			},

			async onFileChange(e) {
				const file = e.target.files[0];
				if (!file) return;
				const formData = new FormData();
				formData.append('file', file);
				try {
					const res = await this.$axios.post(this.$apis.upload, formData);
					if (res && res.code === 1) {
						if (this.currentUploadType === 'logo') {
							this.form.logo = res.data.url;
							this.previewLogo = res.data.fullurl;
						} else {
							this.form.robot_avatar = res.data.url;
							this.previewRobotAvatar = res.data.fullurl;
						}
						this.$message.success('上传成功');
					}
				} catch (err) {
					this.$message.error('上传失败');
				} finally {
					e.target.value = '';
				}
			},

			async handleSave() {
				const valid = await this.$refs.form.validate().catch(() => false);
				if (!valid) return;

				this.submitting = true;
				try {
					const subtitleObj = {
						switch: this.enableSubtitle ? 1 : 0,
						content: {
							online: this.onlineMsg,
							offline: this.offlineMsg
						}
					};
					const noticeObj = {
						switch: this.showNotice ? 1 : 0,
						color: this.noticeColor,
						type: this.noticeStyle === 'full' ? 'all' : 'slider',
						content: this.noticeContent,
						jump: {
							switch: this.enableNoticeJump ? 1 : 0,
							url: this.noticeJumpLink
						}
					};

					this.form.logo = this.form.id ? this.form.logo.match(/\/uploads\/.*/)[0] : this.form.logo
					this.form.robot_avatar = this.form.id ? this.form.logo.match(/\/uploads\/.*/)[0] : this.form.robot_avatar
					const postData = {
						...this.form,
						subtitle: JSON.stringify(subtitleObj),
						notice: JSON.stringify(noticeObj),
					};

					const api = this.form.id ? this.$apis.editChannel : this.$apis.addChannel;
					const res = await this.$axios.post(api, postData);
					if (res && res.code === 1) {
						this.$message.success('成功');
						this.$emit('refresh');
						this.$emit('back');
					} else {
						this.$message.error(res.msg || '失败');
					}
				} catch (e) {
					this.$message.error('接口请求异常');
				} finally {
					this.submitting = false;
				}
			}
		}
	};
</script>

<style lang="scss" scoped>
	.create-plugin {
		padding: 15px;
		background: #fff;
		min-height: 100%;

		.config-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding-bottom: 15px;
			border-bottom: 1px solid #f0f2f5;
			margin-bottom: 20px;
		}

		.main-form {
			max-width: 900px;
		}

		.section {
			margin-bottom: 30px;
		}

		.section-title {
			margin-bottom: 20px;
			color: #333;
			border-left: 4px solid #409EFF;
			padding-left: 12px;
			font-size: 15px;
		}

		.form-row {
			display: flex;
			align-items: flex-start;
		}

		.flex-1 {
			flex: 1;
		}

		.ml-20 {
			margin-left: 20px;
		}

		.color-list {
			display: flex;
			align-items: center;
			gap: 8px;
			padding: 5px 5px;

			.color-dot {
				width: 24px;
				height: 24px;
				border-radius: 50%;
				cursor: pointer;
				display: flex;
				align-items: center;
				justify-content: center;
				color: #fff;

				&.active {
					transform: scale(1.1);
					box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
				}
			}
		}

		.avatar-row {
			display: flex;
			align-items: center;

			.avatar-item {
				display: flex;
				align-items: center;
			}

			.upload-box {
				width: 60px;
				height: 60px;
				border: 1px solid #e4e7ed;
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				overflow: hidden;
				background: #fff;
				flex-shrink: 0;

				i {
					font-size: 20px;
					color: #909399;
				}

				.img-full {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}

				&:hover {
					border-color: #409EFF;
				}
			}

			.avatar-info {
				margin-left: 12px;
				line-height: 1.4;

				.label {
					font-size: 13px;
					color: #606266;
				}

				.tip {
					font-size: 12px;
					color: #c0c4cc;
				}
			}
		}

		.notice-box-ui {
			background: #f9fbfd;
			padding: 20px;
			border-radius: 4px;
			border: 1px solid #edf1f7;
			margin-top: 10px;
		}

		.gray {
			color: #909399;
		}

		.f-13 {
			font-size: 13px;
		}

		.mt-20 {
			margin-top: 20px;
		}

		.flex-center {
			display: flex;
			align-items: center;
		}
	}
</style>